export default [
  { code: 'Accounting', label: 'Accounting' },
  {
    code: 'Administration & Office Support',
    label: 'Administration & Office Support'
  },
  { code: 'Advertising, Arts & Media', label: 'Advertising, Arts & Media' },
  {
    code: 'Banking & Financial Services',
    label: 'Banking & Financial Services'
  },
  {
    code: 'Call Centre & Customer Service',
    label: 'Call Centre & Customer Service'
  },
  {
    code: 'Community Services & Development',
    label: 'Community Services & Development'
  },
  { code: 'Construction', label: 'Construction' },
  { code: 'Consulting & Strategy', label: 'Consulting & Strategy' },
  { code: 'Design', label: 'Design' },
  { code: 'Education & Training', label: 'Education & Training' },
  { code: 'Engineering', label: 'Engineering' },
  {
    code: 'Farming, Animals & Conservation',
    label: 'Farming, Animals & Conservation'
  },
  { code: 'Government & Defence', label: 'Government & Defence' },
  { code: 'Healthcare & Medical', label: 'Healthcare & Medical' },
  { code: 'Hospitality & Tourism', label: 'Hospitality & Tourism' },
  {
    code: 'Human Resources & Recruitment',
    label: 'Human Resources & Recruitment'
  },
  {
    code: 'Information & Communication Technology',
    label: 'Information & Communication Technology'
  },
  { code: 'Insurance & Superannuation', label: 'Insurance & Superannuation' },
  { code: 'Legal', label: 'Legal' },
  {
    code: 'Manufacturing, Transport & Logistics',
    label: 'Manufacturing, Transport & Logistics'
  },
  { code: 'Marketing & Communications', label: 'Marketing & Communications' },
  { code: 'Mining, Resources & Energy', label: 'Mining, Resources & Energy' },
  { code: 'Real Estate & Property', label: 'Real Estate & Property' },
  { code: 'Retail & Consumer Products', label: 'Retail & Consumer Products' },
  { code: 'Sales', label: 'Sales' },
  { code: 'Science & Technology', label: 'Science & Technology' },
  { code: 'Sport & Recreation', label: 'Sport & Recreation' },
  { code: 'Trades & Services', label: 'Trades & Services' }
]
